import React from 'react';
import {
  node,
  string,
  objectOf,
  oneOfType,
  number,
  bool,
  func,
} from 'prop-types';
import styles from './DefaultParagraph.module.scss';

const DefaultParagraph = (props) => {
  const {
    children,
    className,
    style,
    small,
    xsmall,
    onClick,
  } = props;

  let sizeStyling = null;
  if (small) {
    sizeStyling = styles.paragraphSmall;
  } else if (xsmall) {
    sizeStyling = styles.paragraphXsmall;
  }

  return (
    <p
      style={style}
      className={[sizeStyling, className].join(' ')}
      onClick={onClick}
    >
      {children}
    </p>
  );
};

DefaultParagraph.propTypes = {
  children: node,
  className: string,
  style: objectOf(oneOfType([
    string,
    number,
  ])),
  small: bool,
  xsmall: bool,
  onClick: func,
};

DefaultParagraph.defaultProps = {
  children: null,
  className: null,
  style: null,
  small: false,
  xsmall: false,
  onClick: null,
};

export default DefaultParagraph;
